type Props = {
  title:       React.ReactNode
  badge?:      { text: string; tone: 'soon' | 'count' }
  countLabel?: string
}

export function RecipesSectionHeader({ title, badge, countLabel }: Props) {
  const badgeClass =
    badge?.tone === 'soon'
      ? 'bg-warn-bg text-warn'
      : 'bg-[#F0EBE0] text-ink-muted'

  return (
    <div className="flex items-baseline gap-[10px] mb-3">
      <h2 className="font-serif text-[20px] font-normal tracking-[-0.01em] text-ink">
        {title}
      </h2>
      {badge && (
        <span className={`rounded-[6px] px-[7px] py-[3px] text-[10px] font-bold uppercase tracking-[0.04em] ${badgeClass}`}>
          {badge.text}
        </span>
      )}
      <div className="flex-1 h-px bg-border-sand" />
      {countLabel && (
        <span className="text-[10px] uppercase tracking-[0.1em] text-ink-muted font-medium">
          {countLabel}
        </span>
      )}
    </div>
  )
}
